module.exports = __webpack_public_path__ + "img/right_qty_1.461de9d2.png";